export default {
  'app.setting.pagestyle': 'Overall Style Settings',
  'app.setting.pagestyle.light': 'Light Menu Style',
  'app.setting.pagestyle.dark': 'Dark Menu Style',
  'app.setting.pagestyle.realdark': 'Real Dark Mode',
  'app.setting.themecolor': 'Theme Color',
  'app.setting.navigationmode': 'Navigation Mode',
  'app.setting.content-width': 'Content Area Width',
  'app.setting.fixedheader': 'Fixed Header',
  'app.setting.fixedsidebar': 'Fixed Sidebar',
  'app.setting.multitab': 'Show Tab',
  'app.setting.sidemenu': 'Side Menu Layout',
  'app.setting.topmenu': 'Top Menu Layout',
  'app.setting.content-width.fixed': 'Fixed',
  'app.setting.content-width.fluid': 'Fluid',
  'app.setting.othersettings': 'Other Settings',
  'app.setting.weakmode': 'Color Weak Mode',
  'app.setting.copy': 'Copy Settings',
  'app.setting.loading': 'Loading Theme',
  'app.setting.copyinfo': 'Copy settings successfully to src/config/defaultSettings.js',
  'app.setting.production.hint': 'The settings panel is only shown in the development environment for preview, and will not be displayed in the production environment. Please copy and modify the configuration file manually',
  'app.setting.themecolor.daybreak': 'Daybreak Blue',
  'app.setting.themecolor.dust': 'Dust Red',
  'app.setting.themecolor.volcano': 'Volcano',
  'app.setting.themecolor.sunset': 'Sunset Orange',
  'app.setting.themecolor.cyan': 'Cyan',
  'app.setting.themecolor.green': 'Aurora Green',
  'app.setting.themecolor.geekblue': 'Geek Blue',
  'app.setting.themecolor.purple': 'Soybean Purple',


}
